module.exports = __webpack_public_path__ + "static/media/intro.751e515d.mp3";